import { Switch } from "@circleco/compass/components/Switch";
import { Controller, useFormContext } from "react-hook-form";

interface SwitchFieldProps {
  label: string;
  labelTooltip?: string;
  name: string;
}

export const SwitchField = ({
  name,
  label,
  labelTooltip,
}: SwitchFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Switch
          checked={Boolean(field.value)}
          label={label}
          labelPosition="end"
          labelTooltip={labelTooltip}
          name={name}
          onBlur={field.onBlur}
          onCheckedChange={field.onChange}
          ref={field.ref}
        />
      )}
    />
  );
};
